import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import clsx from 'clsx';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ChartIcon = function ChartIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.666667 0C1.03486 0 1.33333 0.298477 1.33333 0.666667V9.33333C1.33333 10.0697 1.93029 10.6667 2.66667 10.6667H11.3333C11.7015 10.6667 12 10.9651 12 11.3333C12 11.7015 11.7015 12 11.3333 12H2.66667C1.19391 12 0 10.8061 0 9.33333V0.666667C0 0.298477 0.298477 0 0.666667 0Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.5442 0.0342089C11.8935 0.150641 12.0822 0.528188 11.9658 0.877483L10.648 4.83081C10.1779 6.24128 8.38775 6.66387 7.33645 5.61257L6.38744 4.66357C6.03701 4.31313 5.4403 4.454 5.28358 4.92415L3.96581 8.87748C3.84938 9.22678 3.47183 9.41555 3.12253 9.29912C2.77324 9.18269 2.58446 8.80514 2.7009 8.45585L4.01867 4.50251C4.48883 3.09205 6.27895 2.66946 7.33025 3.72076L8.27926 4.66976C8.62969 5.0202 9.2264 4.87933 9.38312 4.40918L10.7009 0.455846C10.8173 0.10655 11.1949 -0.082223 11.5442 0.0342089Z",
      fill: "#12131A"
    })]
  }));
};

ChartIcon.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const RadioSwitch = _ref => {
  let {
    id,
    className = '',
    options,
    name,
    defaultValue,
    onChange = () => null
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: clsx(styles.container, className),
    children: options.map((option, index) => {
      // Append value to requested identifier
      // to make all options unique
      const optionId = id ? `${id}-${option.value}` : '';
      return /*#__PURE__*/_jsxs("label", _objectSpread(_objectSpread({}, optionId && {
        htmlFor: optionId
      }), {}, {
        children: [/*#__PURE__*/_jsx("input", _objectSpread(_objectSpread({}, optionId && {
          id: optionId
        }), {}, {
          type: "radio",
          name: name,
          value: option.value,
          onChange: onChange,
          defaultChecked: defaultValue ? option.value === defaultValue : index === 0,
          className: styles.container__input
        })), /*#__PURE__*/_jsxs("span", {
          className: styles.text,
          children: [option.label, option.icon === 'chart' && /*#__PURE__*/_jsx(ChartIcon, {})]
        })]
      }), option.value);
    })
  });
};

export default RadioSwitch;